import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Box, Typography, Alert, } from '@mui/material';
// ─── Config ───────────────────────────────────────────────────────────────────
export const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_REACT_APP_API_BASE_URL || '/api';
export const API = `${API_URL}/out-of-office`;
export const EMP_API = `${API_URL}/onboarding/eligible-employees`;
export const LEAVE_API = `${API_URL}/leave-management`;
export const ACCENT = '#2b3d14';
export const TH = { fontWeight: 600, fontSize: 11, color: '#64748b', bgcolor: '#f8fafc', whiteSpace: 'nowrap', py: '10px', borderBottom: '1px solid #e2e8f0' };
export const TD = { fontSize: 12, py: '10px', verticalAlign: 'top' };
export const ELLIPSIS = { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' };
export const fmtDate = (d) => {
    if (!d)
        return '—';
    try {
        return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    }
    catch {
        return String(d);
    }
};
export const fmtTime24 = (d) => {
    if (!d)
        return '—';
    try {
        return new Date(d).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
    }
    catch {
        return String(d);
    }
};
export const fmtDateTime24 = (d) => {
    if (!d)
        return '—';
    try {
        const dt = new Date(d);
        return `${fmtDate(dt)}, ${fmtTime24(dt)}`;
    }
    catch {
        return String(d);
    }
};
export const fmtDayMonth = (d) => {
    if (!d)
        return '—';
    try {
        return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
    }
    catch {
        return String(d);
    }
};
export function Toast({ msg, type, onClose }) {
    useEffect(() => { const t = setTimeout(onClose, 3500); return () => clearTimeout(t); }, [onClose]);
    return (_jsx(Box, { sx: { position: 'fixed', bottom: 24, right: 24, zIndex: 9999, minWidth: 280 }, children: _jsx(Alert, { severity: type, onClose: onClose, sx: { borderRadius: 2 }, children: msg }) }));
}
export function DetailRow({ label, value }) {
    return (_jsxs(Box, { sx: { mb: 1.5 }, children: [_jsx(Typography, { fontSize: 12, color: "text.secondary", children: label }), _jsx(Typography, { component: "div", fontSize: 13, fontWeight: 600, sx: { wordBreak: 'break-word' }, children: value })] }));
}
// ─── Placeholder tabs ────────────────────────────────────────────────────────────
export function ComingSoonTab({ icon, title }) {
    return (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 10, color: 'text.secondary' }, children: [icon, _jsx(Typography, { fontSize: 16, fontWeight: 700, color: "#0f172a", mt: 1.5, children: title }), _jsx(Typography, { fontSize: 12, mt: 0.5, children: "This feature is cooking. Check back soon." })] }));
}
